import * as React from "react"

import AppLayout from "Layout"
import HomePage from "./index"


export const HomeRoutes = {
	path: "/",
	title: "Home",
	icon: 'house',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'User statistics dashboard',
	// No access restriction - available for all user roles
	children: [{
		element: <HomePage />, 
		index: true
	}]
}
